import React, { Component } from 'react';
import moment from 'moment';

import withAuthorization from '../components/withAuthorization';
import { db, realtimeDb } from '../firebase/firebase';
import { auth } from '../firebase/index.js';

import Modal from 'react-modal';
import { showSnackbar, showSnackbarWithType, showSnackbarWithTimeout } from '../components/Snackbar.js';
import { Table } from 'element-react';
import 'element-theme-default';
import RoleUtils from '../utils/RoleUtils';

class News extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newsEntries: [],
            postcodeLabelText: '',
            postcodeText: '',
            workareas: [],
            showNewsDetailsModal: false,
            selectedNews: {
                id: null,
                timestamp: null,
                description: null,
                address: null,
                status: null,
                title: null,
                imageUrl: null,
                content: null,
                subject: null,
                uid: null,
                updatedAt: null,
                postalCodes: ["5571NX", "5571", "1234AB"]
            },
            newComment: '',
            lastSelectedNews: null,
            newStatus: null,
            newCommentFrom: 'Wijkcoordinator',
            columns: [
                {
                    label: "Titel",
                    prop: "title",
                    width: 140,
                    render: (data) => {
                        if (data.title) {
                            return data.title.length > 50
                                ? data.title.substring(0, 50) + '...'
                                : data.title;
                        }
                    }
                },
                {
                    label: "Onderwerp",
                    prop: "subject",
                    width: 150,
                },
                {
                    label: "Datum",
                    prop: "timestamp",
                    width: 130,
                    render: (data) => {
                        if (data.timestamp) {
                            return typeof data.timestamp === 'number'
                                ? moment(data.timestamp).format("dd L")
                                : moment(data.timestamp.toDate()).format("dd L");
                        }

                    },
                    sortable: true,
                },
                {
                    label: "Status",
                    prop: "isPublished",
                    width: 100,
                    render: (data) => {

                        return (
                            <span className={`badge badge-${data.isPublished ? 'success' : 'warning'}`}>
                                {data.isPublished ? 'Gepubliceerd' : 'Concept'}
                            </span>
                        );
                    },
                    sortable: true,
                },
                {
                    label: "Postcodes",
                    prop: "postalCodes",
                    width: 180,
                    render: (data) => {
                        if (data.postalCodes && data.postalCodes.length > 0) {
                            return (
                                <div onClick={() => {
                                    localStorage.setItem('lastSelectedNews', JSON.stringify(data));
                                    localStorage.setItem('openPostalcodesModal', 'true');
                                    localStorage.setItem('rootUserData', JSON.stringify(this.props.rootUserData));
                                    this.props.history.push({
                                        pathname: '/news-edit',
                                        state: { newsData: data }
                                    });
                                }}>
                                    {data.postalCodes.map((code, index) => (
                                        <span key={index} className="badge badge-primary" style={{ marginRight: '5px' }}>
                                            {code}
                                        </span>
                                    ))}
                                    <span className="badge badge-secondary" style={{ marginRight: '5px' }}>
                                        Tik hier om te bewerken
                                    </span>
                                </div>
                            );
                        }
                        return '';
                    },
                },
                {
                    label: "Acties",
                    fixed: 'right',
                    width: 210,
                    render: (data) => {
                        return (
                            <div>
                                <button type="button" className="btn btn-primary" title="Details bekijken"
                                    onClick={() => {
                                        this.setState({ showNewsDetailsModal: true, selectedNews: data });
                                    }} data-toggle="modal" data-target="#logModal">
                                    Bekijken
                                </button>

                                <button className="btn btn-secondary" title="Bewerk artikel" data-toggle="tooltip"
                                    onClick={() => {
                                        localStorage.setItem('lastSelectedNews', JSON.stringify(data));
                                        this.props.history.push({
                                            pathname: '/news-edit',
                                            state: { newsData: data }
                                        });
                                    }}>
                                    <i className="material-icons" title="Bewerk artikel" data-toggle="tooltip">edit</i>
                                </button>

                                <button className="btn btn-danger" title="Verwijderen" data-toggle="tooltip"
                                    onClick={() => {
                                        this.openDeleteNewsModal(data);
                                    }}>
                                    <i className="material-icons" title="Verwijderen" data-toggle="tooltip">delete_forever</i>
                                </button>
                            </div>)
                    }
                }
            ],
        };

        this.postalCodesAlreadyFetched = new Map();
        this.newsByKeyAlreadyFetched = new Map();
    }

    onNewsUpdate = (querySnapshot) => {
        let newsEntries = [...this.state.newsEntries];

        if (querySnapshot == null || querySnapshot.empty) {
            this.setState({ newsEntries: [] });
            return;
        }

        const data = querySnapshot.val();
        console.log('News data received:', data);

        if (newsEntries.findIndex(item => item.id === querySnapshot.key) !== -1) {
            // Update existing news entry
            let index = newsEntries.findIndex(item => item.id === querySnapshot.key);
            newsEntries[index] = {
                id: querySnapshot.key,
                ...data
            };
        } else {
            newsEntries.push({
                id: querySnapshot.key,
                ...data
            });
        }

        if (!data.title) {
            newsEntries = newsEntries.filter(item => item.id !== querySnapshot.key);
        }

        const sortedByDate = newsEntries.sort((a, b) => {
            const dateA = a.timestamp ? (typeof a.timestamp === 'number' ? a.timestamp : a.timestamp.toDate().getTime()) : 0;
            const dateB = b.timestamp ? (typeof b.timestamp === 'number' ? b.timestamp : b.timestamp.toDate().getTime()) : 0;
            return dateB - dateA;
        });

        this.setState({ newsEntries: sortedByDate });
    }

    componentDidMount() {
        this.getMyWorkareas();

        showSnackbarWithTimeout('Gegevens laden..', 1000);
    }

    getMyWorkareas = async () => {
        const userData = await auth.getUserData();
        console.log(userData);
        this.setState({ userData, workareas: [] });
        const workareasRef = realtimeDb.ref(`/workareas/${userData.uid}`);

        workareasRef.on('value', (snapshot) => {
            let workareas = snapshot.val();
            console.log('Fetched workareas:', workareas);

            if (!workareas) {
                workareas = [];
            } else {
                workareas.forEach(workarea => {
                    if (workarea.postcodes && workarea.postcodes.length > 0) {
                        workarea.postcodes.forEach(postcode => {
                            this.getNewsByPostalcode(postcode);
                        });
                    }
                });
            }

            this.setState({ workareas });
        });
    }

    componentWillUnmount() {

    }

    getNewsByPostalcode = async (postcode) => {
        if (this.postalCodesAlreadyFetched.has(postcode)) {
            return;
        }

        if (postcode.length === 4) {
            postcode = postcode + '_mk'; // for meldkamer
        }

        realtimeDb.ref(`/news_by_postalcodes/${postcode}`).once('value', (snapshot) => {
            const newsKeys = snapshot.val();

            if (!newsKeys || Object.keys(newsKeys).length === 0) {
                return;
            }

            for (const key in newsKeys) {
                if (this.newsByKeyAlreadyFetched.has(key)) {
                    continue;
                }
                this.newsByKeyAlreadyFetched.set(key, true);
                const newsRef = realtimeDb.ref(`/news/${key}`);
                newsRef.on('value', (snapshot) => {
                    this.onNewsUpdate(snapshot);
                });
            }

            this.postalCodesAlreadyFetched.set(postcode, true);
        });
    }

    openDeleteNewsModal = (news) => {
        this.setState({ modalDeleteNewsIsOpen: true, lastSelectedNews: news });
    }

    closeDeleteNewsModal = () => {
        this.setState({ modalDeleteNewsIsOpen: false });
    }

    handleDeleteNewsClicked = () => {
        this.closeDeleteNewsModal();
        this.deleteNews();
    }

    deleteNews = () => {
        if (this.state.lastSelectedNews && this.state.lastSelectedNews.id) {
            realtimeDb.ref(`news/${this.state.lastSelectedNews.id}`).remove()
                .then(() => {
                    showSnackbar('Artikel is verwijderd.');
                })
                .catch((error) => {
                    console.error("Error deleting document: ", error);
                    showSnackbarWithType('Er is iets fout gegaan, probeer het nog een keer.', 'error');
                });

            let bulkRemove = {};
            this.state.lastSelectedNews.postalCodes.forEach(postcode => {
                bulkRemove[`news_by_postalcodes/${postcode}/${this.state.lastSelectedNews.id}`] = null;
                bulkRemove[`news_by_postalcodes/${postcode.substring(0, 4)}_mk/${this.state.lastSelectedNews.id}`] = null;
            });

            realtimeDb.ref().update(bulkRemove);

        } else {
            showSnackbarWithType('Geen artikel geselecteerd om te verwijderen.', 'error');
        }

        setTimeout(() => {
            window.location.reload();
        }, 1000);
    }

    closeModal = () => {
        this.setState({ infoModalOpen: false, commentModalOpen: false });
    }

    closeNewsDetailsModal = () => {
        this.setState({ showNewsDetailsModal: false, selectedNews: null });
    }

    closeNewArticleModal = () => {
        this.setState({ showNewArticleModal: false });
    }

    render() {
        if (this.props.rootUserData && (!RoleUtils.hasRole(this.props.rootUserData, RoleUtils.Roles.Wijkagent) && !RoleUtils.hasRole(this.props.rootUserData, RoleUtils.Roles.Gemeente) && !RoleUtils.hasRole(this.props.rootUserData, RoleUtils.Roles.Administrator))) {
            return (
                <div className="container content">
                    <div className="alert alert-danger" role="alert">
                        Je hebt geen toegang tot deze pagina.
                    </div>
                </div>
            );
        }

        return (
            <div className="container logboek  content">

                <h2>Artikelen</h2>
                <span>Gebruik artikelen om lokale nieuws en informatie te delen met inwoners op basis van werkgebieden (postcodes).</span>

                {this.props.rootUserData && (
                    <button
                        type="button"
                        className="btn btn-primary btn-raised"
                        onClick={() => this.props.history.push({
                            pathname: '/workareas',
                            state: {}
                        })}>
                        Werkgebieden beheren
                    </button>
                )}

                {this.props.rootUserData && (
                    <button
                        style={{ marginLeft: 10 }}
                        type="button"
                        className="btn btn-primary btn-raised"
                        onClick={() => {
                            localStorage.setItem('lastSelectedNews', JSON.stringify({}));
                            this.props.history.push({
                                pathname: '/news-edit',
                            });

                        }}>
                        + Nieuw artikel
                    </button>
                )}
                <Table
                    style={{ width: '100%' }}
                    columns={this.state.columns}
                    data={this.state.newsEntries}
                    stripe={true}
                    highlightCurrentRow={true}
                    height={600}
                    onCurrentChange={lastSelectedNews => this.setState({ lastSelectedNews })}
                />

                <Modal
                    className="Modal__Bootstrap modal-dialog modal-lg"
                    closeTimeoutMS={150}
                    isOpen={this.state.showNewsDetailsModal}
                    onRequestClose={this.closeNewsDetailsModal}
                    ariaHideApp={false}
                >
                    {this.state.selectedNews && (
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title"><strong>Titel:</strong> {this.state.selectedNews.title}</h4>
                                <button type="button" className="close" onClick={this.closeNewsDetailsModal}>
                                    <span aria-hidden="true">&times;</span>
                                    <span className="sr-only">Annuleren</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <span><strong>Gemaakt op:</strong> {moment(this.state.selectedNews.timestamp).format("D MMMM YYYY - HH:mm")}</span>
                                <br />
                                <span><strong>Laatste update:</strong> {this.state.selectedNews.updatedAt
                                    ? moment(this.state.selectedNews.updatedAt).format("D MMMM YYYY - HH:mm")
                                    : ''}</span>
                                <br />
                                <span><strong>Onderwerp:</strong> {this.state.selectedNews.subject}</span>
                                {this.state.selectedNews.imageUrl && (
                                    <img src={this.state.selectedNews.imageUrl} alt="Nieuws afbeelding" style={{ width: '100%', height: 'auto' }} />
                                )}
                                <p><strong>Postcodes:</strong> {this.state.selectedNews.postalCodes && this.state.selectedNews.postalCodes.map((code, index) => (
                                    <span key={index} className="badge badge-primary" style={{ marginRight: '5px' }}>
                                        {code}
                                    </span>
                                ))}
                                </p>
                                <p><strong>Inhoud:</strong></p>
                                <div dangerouslySetInnerHTML={{ __html: this.state.selectedNews.content }} />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={this.closeNewsDetailsModal}>Sluiten</button>
                            </div>
                        </div>
                    )}
                </Modal>

                <Modal
                    className="Modal__Bootstrap modal-dialog"
                    closeTimeoutMS={150}
                    isOpen={this.state.modalDeleteNewsIsOpen}
                    onRequestClose={this.closeDeleteNewsModal}
                    ariaHideApp={false}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Artikel verwijderen</h4>
                            <button type="button" className="close" onClick={this.closeDeleteLogModal}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only">Annuleren</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <span>Weet je zeker dat je deze artikel wilt verwijderen? Het verwijderen van een artikel is definitief en niet mogelijk om te herstellen.</span>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={this.closeDeleteNewsModal}>Annuleren</button>
                            <button type="button" className="btn btn-danger btn-outline" onClick={this.handleDeleteNewsClicked}>Verwijderen</button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }

    closeModal = () => {
        this.setState({ infoModalOpen: false, commentModalOpen: false });
    }
}

const authCondition = (authUser) => !!authUser;

export default withAuthorization(authCondition)(News);
